module.exports = __webpack_public_path__ + "static/img/menu_active.5e8cc6e3.svg";